import { ApiKeyFetch } from 'api/fetchers/apiKey';
import { rechazoEncuesta, registroEncuesta, urlLinkEncuestas } from 'constants/urls';
import useQueryParams from 'hooks/useQueryParams';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import React, { forwardRef, useImperativeHandle, useRef } from 'react';
import PRODUCTOS from 'utils/constants/PRODUCTOS';
import { useLoadingScreen } from 'wrappers/LoadingScreen/store';

const API = ApiKeyFetch.instance();

const Encuesta = forwardRef((props, ref) => {
  const { codProducto, idPoliza } = useQueryParams();
  const [_, loadingActions] = useLoadingScreen();
  const myToastEncuestas = useRef(null);

  const closeToastEnceusta = () => {
    myToastEncuestas.current.clear();
  };

  const rechazarEncuesta = async () => {
    const res = await API.post(rechazoEncuesta + idPoliza, {});
    if (res.transaccion === true) {
      closeToastEnceusta();
    }
  };

  const completeEncuesta = async () => {
    loadingActions.setLoading(true);
    const res = await API.post(registroEncuesta + idPoliza + '&redirect=no', {});
    if (res.transaccion === true && res?.urlRedirecionarEncuesta !== '') {
      window.location.href = res?.urlRedirecionarEncuesta;
    }
  };

  const loadEncuesta = async () => {
    // console.log('LOADING ENCUESTA');
    try {
      if (codProducto !== PRODUCTOS.APINDIVIDUAL) {
        
        // if (true) {
        const res = await API.post(urlLinkEncuestas + idPoliza, {});
        console.log('RES ENCUESTA: ', res);
        if (res.transaccion === true) {
          myToastEncuestas.current.show({
            severity: 'info',
            sticky: true,
            content: (
              <div className="p-flex p-flex-column" style={{ flex: '1' }}>
                <div className="p-text-center" style={{ textAlign: 'center' }}>
                  <i className="pi pi-question" style={{ fontSize: '3rem' }}></i>
                  <h4>{res?.msgEncuesta}</h4>
                  <p>{res?.msgEncuestaSub}</p>
                </div>
                <div className="row">
                  <div className="col-6">
                    <Button
                      onClick={() => completeEncuesta()}
                      type="button"
                      label="Yes"
                      className="p-button-success w-100"
                    />
                  </div>
                  <div className="col-6">
                    <Button
                      onClick={() => rechazarEncuesta()}
                      type="button"
                      label="No"
                      className="p-button-secondary w-100"
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-1"></div>
                  <div className="col-10 my-2">
                    <Button
                      onClick={() => closeToastEnceusta()}
                      type="button"
                      label="Responder más tarde"
                      className="p-button-info w-100"
                    />
                  </div>
                  <div className="col-1"></div>
                </div>
              </div>
            ),
          });
        }
      }
    } catch (error) {
      console.log('ERROR ENCUESTA: ', error);
    }
  };

  useImperativeHandle(ref, () => ({
    loadEncuesta,
  }));

  return <Toast ref={myToastEncuestas} position="bottom-center" />;
});

export default Encuesta;
